export default "__VITE_ASSET__Bs96w1Ct__"